import Base from './Base'
import settings from '../Settings'

class BankingAccount extends Base{
    static base_url = settings.BASE_API_URL + "bankingaccount/"
}

export default BankingAccount